export const selectPaymentOptions = state => state.paymentOptions.data;
